import React from 'react';
import { ECardView } from '../../Enums/ECardView.enum';
// @ts-ignore
import styles from './ECardViewSwitch.module.scss';

interface Props {
	view: ECardView;
	setView: (view: ECardView) => void;
}

const ECardViewSwitch: React.FC<Props> = ({ view, setView }) => {
	let component: React.ReactElement = <></>;

	switch (view) {
		case ECardView.GRID:
			component = (
				<>
					<img
						src={'/dist/icons/list-solid-inactive.svg'}
						width={'20px'}
						style={{ cursor: 'pointer' }}
						onClick={() => setView(ECardView.LIST)}
					/>
					<img src={'/dist/icons/grid-solid-active.svg'} width={'20px'} />
				</>
			);
			break;
		case ECardView.LIST:
			component = (
				<>
					<img src={'/dist/icons/list-solid-active.svg'} width={'20px'} />
					<img
						src={'/dist/icons/grid-solid-inactive.svg'}
						width={'20px'}
						style={{ cursor: 'pointer' }}
						onClick={() => setView(ECardView.GRID)}
					/>
				</>
			);
			break;
	}

	return <div className={styles.wrapper}>{component}</div>;
};

export default ECardViewSwitch;
